import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { LatLng } from 'shared/types';
import { WeatherStation } from '../../weatherStations.types';

type UseWeatherStationProps = {
  id?: number;
};

type UseWeatherStation = Omit<UseQueryResult<WeatherStation, Error>, 'data'> & {
  weatherStation?: WeatherStation;
};

export type ServerWeatherStation = {
  id: WeatherStation['id'];
  name: WeatherStation['name'];
  data: {
    elevation: WeatherStation['elevation'];
    stid: WeatherStation['stid'];
  };
  location: LatLng;
  isOffline: boolean;
};

const fetchWeatherStation = async (
  weatherStationId: number | string,
): Promise<WeatherStation> => {
  const response = await API.get<ServerWeatherStation>(
    `weather/station/${weatherStationId}/`,
  );

  const { data, ...serverWeatherStationRoot } = response.data;

  return {
    ...serverWeatherStationRoot,
    ...data,
  };
};

export const useWeatherStation = (
  props: UseWeatherStationProps,
): UseWeatherStation => {
  const { id } = props;

  const { data, ...results } = useQuery({
    queryKey: ['weatherStation', id],
    queryFn: () => fetchWeatherStation(id!),
    enabled: Boolean(id),
  });

  return {
    ...results,
    weatherStation: data,
  };
};
